import feelGoodProductivity from './feelGoodProductivity';
import atomicHabits from './surroundedByIdiots';


export const books = [feelGoodProductivity, atomicHabits];

export { feelGoodProductivity, atomicHabits };
